module.exports = __webpack_public_path__ + "43bba1f6e86bafde0162c36fc575f226.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-italic/opensans-italic.ttf
// module id = ./src/styles/fonts/opensans-italic/opensans-italic.ttf
// module chunks = index